import { TechnicalDataDto } from '@vpfa/rest-api/valuation';

export const firstVehiclePrice = (
  technicalData: TechnicalDataDto | null
): TechnicalDataDto['vehiclePrices'][0] | null => {
  return technicalData?.vehiclePrices ? technicalData.vehiclePrices[0] : null;
};
